module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/assets/fonts/fontawesome-webfont.eot
// module id = ../../../../../src/assets/fonts/fontawesome-webfont.eot
// module chunks = styles